import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "./SplashScreen.css";
import logo from "./logo.png";

function SplashScreen({ onFinish }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 2200); // 2.2 saniye sonra geçiş

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <motion.div
      className="splash-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.img
        src={logo}
        alt="Logo"
        className="splash-logo"
        initial={{ scale: 0.5, opacity: 0, rotate: -5 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
      />
    </motion.div>
  );
}

export default SplashScreen;
